const CLASS_EXTENSION = '-list-item';

export const MODULE_CLASS = `module${CLASS_EXTENSION}`;
export const SUBMODULE_CLASS = `submodule${CLASS_EXTENSION}`;
export const PERMISSION_CLASS = `permission${CLASS_EXTENSION}`;
export const SUBPERMISSION_CLASS = `subpermission${CLASS_EXTENSION}`;
export const INVALID_PERMISSION_CLASS = `invalid-permission${CLASS_EXTENSION}`;
